import { render, staticRenderFns } from "./opendialog-Rrgin.vue?vue&type=template&id=5c8c5098&scoped=true"
import script from "./opendialog-Rrgin.vue?vue&type=script&lang=ts"
export * from "./opendialog-Rrgin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c5098",
  null
  
)

export default component.exports